import { usePage } from '@/hooks'
import React from 'react'
import { Link } from 'react-router-dom'
import HtmlContent from '../HtmlContent'
import style from './styles/contest.module.scss'

interface IProps {
  id: string | number
  image: string
  title: string
  theme: string
  date: string
}

const CabinetContestCard = ({
  id,
  image,
  title,
  theme,
  date
}: IProps): React.ReactElement => {
  const page = usePage()

  const { config } = page?.init_state?.global

  const { contest_detail: contestDetail } = config
  return (
    <Link to={`${contestDetail}?element_id=${id}`} className={style.cabinet__link}>
      <img
        src={image}
        alt={title}
        width='320px'
        height='200px'
        className={style.cabinet__image}
      />
      <div className={style.cabinet_right}>
        <div>
          <span className={style.cabinet__title}>{title}</span>
          <div className={style.cabinet__theme}>
            Тема:{' '}
            <HtmlContent content={theme} className={style.cabinet__text} />
          </div>
        </div>
        <span className={style.cabinet__date}>{date}</span>
      </div>
    </Link>
  )
}

export default CabinetContestCard
